// extracted by mini-css-extract-plugin
export default {"imageArticleWp":"index_imageArticleWp_U-SGg"};